import { ServerError } from "@mcleod/core";

export class ReportData {
    public excelBytes: string;
    public hasExceptions: boolean;
    public pdfBytes: string;
    public reportName: string;
    public reportType: string;
    private _serverError: ServerError;

    constructor(reportName: string, options: Partial<ReportData> = {}) {
        this.reportName = reportName;
        this.excelBytes = options.excelBytes;
        this.hasExceptions = options.hasExceptions;
        this.pdfBytes = options.pdfBytes;
        this.reportType = options.reportType;
        this._serverError = options.serverError;
    }

    public get serverError(): ServerError {
        return this._serverError;
    }

    public set serverError(error: ServerError | string) {
        if (typeof error === 'string') {
            this._serverError = new ServerError({ message: error });
        } else {
            this._serverError = error;
        }
    }
}
